import FuseNavigation from '@fuse/core/FuseNavigation';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import clsx from 'clsx';
import { memo, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectNavigation } from 'app/store/fuse/navigationSlice';
import { navbarCloseMobile } from '../../store/fuse/navbarSlice';
import { selectIsTranslationsInitialized } from 'app/store/i18nSlice';

function Navigation(props) {
  const navigation = useSelector(selectNavigation);
  const theme = useTheme();
  const mdDown = useMediaQuery(theme.breakpoints.down('lg'));
  const dispatch = useDispatch();
  // Obtener el idioma actual para forzar el re-render
  const language = useSelector(state => state.i18n.language);
  const translationsReady = useSelector(selectIsTranslationsInitialized);

  // Memoizar el handler para evitar recrearlo en cada render
  const handleItemClick = useCallback((item) => {
    if (mdDown) {
      dispatch(navbarCloseMobile());
    }
  }, [mdDown, dispatch]);

  // Memoizar el className para evitar recrearlo
  const navigationClassName = useMemo(() => clsx('navigation', props.className), [props.className]);

  // No renderizar hasta que las traducciones estén listas
  if (!translationsReady) return null;

  return (
    <FuseNavigation
      key={language} // Forzar re-mount al cambiar idioma
      className={navigationClassName}
      navigation={navigation}
      layout={props.layout}
      dense={props.dense}
      active={props.active}
      onItemClick={handleItemClick}
    />
  );
}

Navigation.defaultProps = {
  layout: 'vertical',
};

export default memo(Navigation);
